import { CalloutWithTitle } from "@/components/ui/callout";
import { SpanNode } from "@/types/spans";
import { ExclamationIcon } from "@heroicons/react/outline";
import { formatDate } from "../utils";

const Exceptions = ({ span }: { span: SpanNode }) => {
  const exceptionEvents = span.events.filter(
    (event) => event.name === "exception",
  );

  if (exceptionEvents.length === 0) return null;

  return (
    <CalloutWithTitle title="Exceptions" className="border-red-200 bg-red-50">
      <div className="space-y-4">
        {exceptionEvents.map((event, index) => (
          <div key={index} className="border-l-4 border-red-400 pl-4">
            <div className="mb-2 flex items-center">
              <ExclamationIcon className="mr-2 h-4 w-4 text-red-500" />
              <span className="font-medium text-red-800">
                {event.attributes?.["exception.type"] || "Exception"}
              </span>
              <span className="ml-2 text-sm text-gray-500">
                {formatDate(
                  new Date(event.timestamp / 1_000_000).toISOString(),
                )}
              </span>
            </div>
            {event.attributes?.["exception.message"] && (
              <div className="mb-2">
                <p className="text-sm font-medium text-gray-600">Message:</p>
                <p className="text-red-700">
                  {event.attributes["exception.message"]}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </CalloutWithTitle>
  );
};

export default Exceptions;
